import { baseNotificationsApi } from './redux';

export const NotificationsCoreMiddlewares = [
  baseNotificationsApi.middleware,
];

export const NotificationsCoreReducers = {
  [baseNotificationsApi.reducerPath]: baseNotificationsApi.reducer,
};
